<template>
    <div class="vue-rental-option-modal-wrapper">
        <component :is="useScrollbar ? 'perfect-scrollbar' : 'div'">
            <div class="modal-header d-flex justify-content-between align-items-start">
                <div class="information-button"></div>

                <button class="close-button mt-1" @click="handleClose">
                    {{ translations.closeText }}
                </button>
            </div>

            <div class="modal-body">
                <div class="modal-description" v-html="description"></div>
            </div>
        </component>
    </div>
</template>

<script>
import translations from "../../mixins/translations";

export default {
    name: "ModalWrapper",

    mixins: [translations],

    props: {
        description: {
            type: String,
            default: ''
        },
        useScrollbar: {
            type: Boolean,
            default: true
        }
    },

    methods: {
        handleClose() {
            this.$modal.close();
        }
    }
}
</script>
